<template>
<div>
  <div>
    <!-- <v-breadcrumbs
      class="px-0"
      :items="[{ text: '出欠管理', href: '/attendance/list' }, { text: '登園・降園' }]"
    ></v-breadcrumbs> -->
  </div>
  <div>
    <h3>{{ $t('features.nursery-web-staff-attendance-management') }}</h3>
  </div>
  <v-row>
    <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
  </v-row>

  <v-dialog v-model="dialog" width="620px">
    <v-card>
      <v-card-title>{{ selectedUser ? (selectedUser.lastName + ' ' + selectedUser.firstName) : '' }}</v-card-title>
      
      <v-card-text>
        <v-container class="py-8">
          <v-row class="pt-8">
            <v-col cols="6">
              <v-btn
                :disabled="!shouldAttendButtonEnabled"
                color="primary"
                block
                style="height: 18vh; font-size: 1.8rem;"
                @click="attend"
                variant="flat"
                class="custom-disabled-btn"
              >Clock In<br>
              {{ attendedTime }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                :disabled="!shouldLeftButtonEnabled || shouldAttendButtonEnabled"
                color="secondary"
                block
                style="height: 18vh; font-size: 1.8rem;"
                @click="left"
                variant="flat"
                class="custom-disabled-btn"
              >Clock Out<br>
              {{ leftTime }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <div>
          <v-progress-linear
            v-if="isUpdating"
            indeterminate
            color="primary"
            class="my-8"
          ></v-progress-linear>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn @click="() => dialog = false" variant="text" color="grey">{{ $t('common.close') }}</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-container fluid class="mt-10">
    <v-row style="height: 100vh;">
      <v-col cols="10" align-self="center" style="height: 100vh;">
        <kana-list :kanaArray="kanaList" @kana-clicked="clickKana"></kana-list>
      </v-col>
      <v-col cols="2">
        <v-list nav bg-color="primary">
          <v-list-subheader class="text-white font-weight-bold">Staff</v-list-subheader>
          <v-divider 
              color="white" 
              thickness="1" 
              class="opacity-100"
          ></v-divider>
          <v-list-item
            v-for="item in staffList"
            :key="item.userId"
              @click="clickStaff(item)"
            link
          >
            <v-list-item-title class="text-white font-weight-bold">
              {{ item.lastName + ' ' + item.firstName }}
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import KanaList from '@/components/atoms/KanaList.vue';
import LocalDataService from '@/service/LocalDataService';
import { childrenModule } from '@/store/dataModules/childrenModule';
import { attendanceModule } from '@/store/dataModules/attendanceModule';
import dayjs from 'dayjs';
import Swal from 'sweetalert2';
import { ChildResponse, NurseryAttendanceResponse, NurseryChildResponse, TimecardResponse } from 'chaild-api/lib';
import { ChildForAttendance } from '@/api/ApiChildren';
import { staffModule } from '@/store/dataModules/staffModule';
import { staffAttandanceManagementModule } from '@/store/viewModules/timecard/staffAttendaceModule'
import { NurseryUserResponse } from 'chaild-api/src/component/nursery/user/types';
import ApiTimecard from "@/api/ApiTimecard";

interface DataType {
  dialog: boolean;
  selectedUser: NurseryUserResponse | null;
  selectedKana: string | null;

  isUpdating: boolean;
  loading: boolean;
}

export default defineComponent({
  name: 'StaffAttendanceManagement',

  components: {
    KanaList,
  },

  async mounted() {
    // attendanceModule.setDate(dayjs().format('YYYY-MM-DD'));
    // await this.listDailyAttendances();
    this.listDailyAttendances();
    await this.fetchStaffList();
  },

  // 押したひらがなに応じて変化させる

  data: (): DataType => {
    return {
      dialog: false,
      selectedUser: null,
      selectedKana: null,

      isUpdating: false,
      loading: false,
    }
  },

  computed: {
    childrenList(): ChildForAttendance[] {
      if (this.selectedKana) {
        const target = childrenModule.kanaList.filter((childrenWithKana) => childrenWithKana.value === this.selectedKana);
        return target.flatMap((childrenWithKana) => childrenWithKana.children);
      }

      return [];

      // return childrenModule.kanaList.flatMap((childrenWithKana) => childrenWithKana.children);
    },
    staffList() {
      if (this.selectedKana) {
        const target = staffAttandanceManagementModule.staffList.filter(
          (staff) => staff.value === this.selectedKana && !staff.nurseryUser?.isHidden
        );
        return target.flatMap((staff) => staff.nurseryUser);
      }
      return [];
    },
    kanaList: function() {
      const items = staffAttandanceManagementModule.staffList.flatMap((item) => {
        if (item.nurseryUser && !item.nurseryUser.isHidden) {
          return item.value;
        }
        return [];
      });
      return [...new Set(items)];
    },
    selectedUserAttendance(): TimecardResponse | null {
      if (this.selectedUser) {
        const found = staffAttandanceManagementModule.attendances.find(
          (at) => at.nurseryUser?.userId === this.selectedUser?.userId && !at.nurseryUser?.isHidden
        );

        if (found) {
          return found;
        }
      }

      return null;
    },
    shouldAttendButtonEnabled(): boolean {
      if (this.isUpdating) {
        return false;
      }
      if (this.selectedUserAttendance && this.selectedUserAttendance.attendedAt) {
        return false;
      }
      return true;
    },
    shouldLeftButtonEnabled(): boolean {
      if (this.isUpdating) {
        return false;
      }
      if (this.selectedUserAttendance && this.selectedUserAttendance.leftAt) {
        return false;
      }
      return true;
    },
    attendedTime(): string | null {
      if (this.selectedUserAttendance && this.selectedUserAttendance.attendedAt) {
        return dayjs(this.selectedUserAttendance.attendedAt).format('HH:mm')
      }
      return null;
    },
    leftTime(): string | null {
      if (this.selectedUserAttendance && this.selectedUserAttendance.leftAt) {
        return dayjs(this.selectedUserAttendance.leftAt).format('HH:mm')
      }
      return null;
    },
  },

  methods: {
    async fetchStaffList() {
      this.loading = true;
      await staffAttandanceManagementModule.getStaffList();
      this.loading = false;
    },
    async listDailyAttendances() {
      await staffAttandanceManagementModule.getAttendances();
    },
    clickKana(value: string) {
      this.selectedKana = value;
    },
    clickStaff(value: NurseryUserResponse) {
      this.selectedUser = value;
      this.dialog = true;
    },
    async attend() {

      if (this.selectedUser) {
        console.log('attend')
        const userId = this.selectedUser.userId;

        const today = dayjs().format('YYYY-MM-DD');
        const now = dayjs().toISOString();

        try {
          this.isUpdating = true;
          const response = await ApiTimecard.clockStaffAttendance({
            userId,
            date: today,
            attendedAt: now
          })

          if (response) {
            await Promise.all([
              this.fetchStaffList(),
              this.listDailyAttendances()
            ]);
            Swal.fire({ title: 'Clocked in', icon: 'success', toast: true, position: 'top-end', timer: 1000});
            window.setTimeout(() => {
                        this.dialog = false;
                      }, 1000);
          } else {
            throw(undefined)
          }
        } catch {
          Swal.fire({ title: this.$t('common.error'), icon: 'error', toast: true, position: 'top-end'});
        }

        this.isUpdating = false;
      }
    },
    async left() {
      const today = dayjs().format('YYYY-MM-DD');
      const now = dayjs().toISOString();

      if (this.selectedUser && this.selectedUserAttendance && this.selectedUserAttendance.attendedAt) {
        const userId = this.selectedUser.userId;
        try {
          this.isUpdating = true;
          const response = await ApiTimecard.clockStaffAttendance({
            userId,
            date: today,
            attendedAt: this.selectedUserAttendance.attendedAt,
            leftAt: now as string
          })

          if (response) {
            await Promise.all([
              this.fetchStaffList(),
              this.listDailyAttendances()
            ]);
            Swal.fire({ title: 'Clocked out', icon: 'success', toast: true, position: 'top-end', timer: 1000});
            window.setTimeout(() => {
                        this.dialog = false;
                      }, 1000);
          } else {
            throw(undefined)
          }
        } catch {
          Swal.fire({ title: this.$t('common.error'), icon: 'error', toast: true, position: 'top-end'});
        }

        this.isUpdating = false;
      }
    },
  },
})
</script>
<style scoped>
/* disabled（非活性）になった時だけ、強制的にグレーに塗りつぶす */
.custom-disabled-btn.v-btn--disabled {
  background-color: #9e9e9e !important; /* お好みのグレーのカラーコード */
  color: #ffffff !important; /* 文字色は白に固定 */
  opacity: 1 !important; /* Vuetify特有の「半透明になる」のを打ち消す */
}
</style>